
import format from 'date-fns/format';
import Vue from 'vue';

// Models
import { VFair } from '~/services/types/vfair';
import { IS_PROD } from '~/router';
import URLS from '~/URLS';
import isSameDay from 'date-fns/isSameDay';

// Constants
const VFAIR_ID_PROD = 'fc02afce-2172-4e71-b81d-efd0de166d8e';
const VFAIR_ID_STAGING = 'f791ea66-6693-4093-a12b-b0f092c37f97';
const VFAIR_ID_TEST = 'f791ea66-6693-4093-a12b-b0f092c37f97';

// Types
interface ConferenceDay {
    videoId: string;
    title: string;
    time: number;
    dayTitle?: string;
    hideDayTitle?: boolean;
    isActive?: boolean;
}

interface ConferenceConfig {
    days: ConferenceDay[];
}

// NOTE: This implementation is just a temporarly hack atm. Logic for 'conference' need to be reimplemented in the future.
export default Vue.extend({
    name: 'VFairConference',
    props: {
        vfair: {
            type: Object as () => { data: VFair },
            required: true,
        },
    },
    data: () => ({
        isInitialized: false,
        domain: window.location.hostname,
        link: 'https://gethighered.com/live-stream/',
        config: [] as ConferenceDay[],
        activeDay: null as ConferenceDay | null,
        timer: null as number | null,
    }),
    computed: {
        vfairData(): VFair | null {
            return this.vfair && this.vfair.data ? this.vfair.data : null;
        },
    },
    methods: {
        getDayLabel(idx: number, day: ConferenceDay) {
            const timeString = format(new Date(day.time), 'p');
            if (day.hideDayTitle) {
                return timeString;
            }

            const dayString =
                day.dayTitle || this.$t('vfair.conference.dayN', { n: idx + 1 }).toString();
            return `${dayString} - ${timeString}`;
        },

        // @deprecated
        checkForValidFairs() {
            if (
                this.vfairData &&
                !(
                    this.vfairData.id === VFAIR_ID_PROD ||
                    this.vfairData.id === VFAIR_ID_STAGING ||
                    this.vfairData.id === VFAIR_ID_TEST
                )
            )
                this.$router.push(URLS.vfair.concat('/', this.vfairData.id));
        },
        initalize() {
            const vFairId = this.vfairData ? this.vfairData.id : null;
            if (!vFairId) {
                this.isInitialized = true;
                return;
            }
            // fixed config for all (!) events, actually single conference config is supported
            fetch(`https://content.gethighered.global/vevent/conference/config.json`, {
                method: 'GET',
                headers: {},
            })
                .then(res => res.json())
                .then((config: ConferenceConfig) => {
                    this.config = config?.days || [];
                    this.config.sort((x, y) => {
                        return (x.time || 0) - (y.time || 0);
                    });
                    this.updateActiveConference();
                    this.timer = setInterval(() => this.updateActiveConference(), 1000);
                    const defaultConference = this.config.length ? this.config[0] : null;
                    const activeConference = this.config.find(x => x.isActive) || defaultConference;
                    const routeConferenceId = this.$route?.params?.conferenceId;
                    const routeConferenceIndex = /^\d\d?$/.test(routeConferenceId)
                        ? Number(routeConferenceId) - 1
                        : null;
                    this.activeDay = routeConferenceId
                        ? this.config.find(
                              (x, index) =>
                                  x.videoId === routeConferenceId || index === routeConferenceIndex
                          ) || activeConference
                        : activeConference;
                })
                .finally(() => (this.isInitialized = true));
        },
        updateActiveConference() {
            this.config.forEach(
                x => (x.isActive = x.time < new Date().getTime() && isSameDay(new Date(), x.time))
            );
            this.config
                .filter(x => x.isActive)
                .reverse()
                .forEach((x, index) => (x.isActive = index === 0));
            this.config = [...this.config];
        },
    },
    mounted() {
        // this.checkForValidFairs();
        this.initalize();
    },
    destroyed() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
});
